import {http} from "../http";

export interface TransactionStatus{
    status : string,
    message : string,
    data : {
        authType : string;
        customerNo : string;
        phoneNumber : string;
        userId : string;
        message : string;
        certIdentifier : string;
        verfication : string;
        timeStamp : string;
        trnRequestType : string;
        lastStatus : string;
        userName : string;
        userRole : string;
        fin : string;
        signerLongName : string;
        asanTransactionId : string;
        trnDetails : any;
    },
    code : number
}

export const getTransactionStatus = async (code): Promise<TransactionStatus> => {
    const { data } = await http.get<TransactionStatus>(`transaction/status/${code}`);
    return data;
};
